import { useState } from "react";

import type { TimelineWeek } from "../types";

interface UseEditorHistoryParams {
  setWeeks: React.Dispatch<React.SetStateAction<TimelineWeek[]>>;
}

export const useEditorHistory = ({ setWeeks }: UseEditorHistoryParams) => {
  const [history, setHistory] = useState<TimelineWeek[][]>([]);
  const [historyIndex, setHistoryIndex] = useState(-1);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const saveToHistory = (newWeeks: TimelineWeek[]) => {
    const newHistory = history.slice(0, historyIndex + 1);
    newHistory.push(JSON.parse(JSON.stringify(newWeeks))); // Deep clone

    if (newHistory.length > 50) {
      newHistory.shift();
    } else {
      setHistoryIndex(historyIndex + 1);
    }

    setHistory(newHistory);
    setHasUnsavedChanges(true);
  };

  const handleUndo = () => {
    if (historyIndex > 0) {
      const previousState = history[historyIndex];
      setWeeks(JSON.parse(JSON.stringify(previousState))); // Deep clone
      setHistoryIndex(historyIndex - 1);
      setHasUnsavedChanges(true);
    }
  };

  const resetHistory = (initialWeeks: TimelineWeek[]) => {
    setHistory([JSON.parse(JSON.stringify(initialWeeks))]);
    setHistoryIndex(0);
    setHasUnsavedChanges(false);
  };

  return {
    canUndo: historyIndex > 0,
    hasUnsavedChanges,
    handleUndo,
    resetHistory,
    saveToHistory,
    setHasUnsavedChanges,
  };
};
